
import { getFallbackDealersData } from "./fallbacks";

interface Coordinates {
  latitude: number;
  longitude: number;
}

/**
 * Fetches data from separate views: vw_dealers_with_ratings and vw_active_quotations
 * Optimization: Using available views and combining the data
 */
export const fetchDataFromSources = async (
  selectedMetal: string,
  signal?: AbortSignal,
  coordinates?: Coordinates | null,
  limitCount?: number
): Promise<{
  dealersData: any[]
}> => {
  try {
    // Import the service that fetches and combines data from the separate views
    const { fetchDealersWithQuotations } = await import('../services/dealerService');
    
    // Fetch data from the views and combine them - pass coordinates for distance sorting
    const dealersData = await fetchDealersWithQuotations(selectedMetal, signal, coordinates, limitCount);
    
    // Check if we have valid dealer data
    if (!dealersData || !Array.isArray(dealersData) || dealersData.length === 0) {
      // Return fallback data (which now only comes from localStorage cache)
      return {
        dealersData: getFallbackDealersData(selectedMetal)
      };
    }
    
    return {
      dealersData
    };
  } catch (error) {
    console.error("Error fetching dealer source data:", error);
    
    // Return fallback data from localStorage only
    return {
      dealersData: getFallbackDealersData(selectedMetal)
    };
  }
};
